import { useState } from 'react';
import { TOPICS } from '../data/topics';

const PlaneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 16.21v-1.45a2 2 0 0 0-1.14-1.8l-5-2.5A2 2 0 0 0 14 10.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4"/>
    <path d="M18 21l4-4-4-4"/><path d="M14 17h8"/>
  </svg>
);

const MenuToggleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const icons = {
  dashboard: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  lessons:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
  quiz:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
  aero:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>,
  weather:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>,
  nav:       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/><line x1="2" y1="12" x2="22" y2="12"/></svg>,
  regs:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
};

export default function Sidebar({ activePage, onNavigate, onSelectTopic }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (id, callback) => {
    callback();
    setMenuOpen(false);
  };

  return (
    <>
      {!menuOpen && (
        <button 
          className="mobile-menu-toggle" 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <MenuToggleIcon />
        </button>
      )}
      <aside 
        className={`sidebar ${menuOpen ? 'menu-open' : ''}`}
        onClick={(e) => {
          // Close menu if clicking on the backdrop (::before pseudo-element area)
          if (e.target === e.currentTarget) {
            setMenuOpen(false);
          }
        }}
      >
        <div className="sidebar-logo">
          <div className="logo-mark"><PlaneIcon />PILOTPATH</div>
          <div className="logo-sub">Private Pilot Ground School</div>
        </div>
        <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-label">Main</div>
          {[
            { id: 'dashboard', label: 'Dashboard' },
            { id: 'lessons',   label: 'AI Lessons',    badge: 'AI' },
            { id: 'quiz',      label: 'Practice Quiz' },
          ].map(({ id, label, badge }) => (
            <button
              key={id}
              className={`nav-item ${activePage === id ? 'active' : ''}`}
              onClick={() => handleNavClick(id, () => onNavigate(id))}
            >
              {icons[id]}{label}
              {badge && <span className="nav-badge">{badge}</span>}
            </button>
          ))}
        </div>
        <div className="nav-section">
          <div className="nav-label">Topics</div>
          {['aero','weather','nav','regs'].map((key) => (
            <button
              key={key}
              className="nav-item"
              onClick={() => handleNavClick(key, () => { onNavigate('lessons'); onSelectTopic(key); })}
            >
              {icons[key]}{TOPICS[key].label.split('&')[0].trim()}
            </button>
          ))}
        </div>
      </nav>
      <div className="sidebar-footer">
        <div className="xp-label"><span>XP Progress</span><span>620 / 1000</span></div>
        <div className="xp-bar"><div className="xp-fill" /></div>
        <div className="user-info">
          <div className="avatar">JD</div>
          <div>
            <div className="user-name">John Doe</div>
            <div className="user-rank">Student Pilot</div>
          </div>
        </div>
      </div>
      </aside>
    </>
  );
}
